import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../../assets/audioGuide/search.png';
import _imports_1 from '../../../assets/audioGuide/location.png';
const _hoisted_1 = {
  class: "audioGuide"
};
const _hoisted_2 = {
  class: "searchBox"
};
const _hoisted_3 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "title-box"
};
const _hoisted_8 = {
  class: "exhibition-title"
};
const _hoisted_9 = {
  class: "museum-list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "exhibition-name"
};
const _hoisted_13 = {
  class: "type"
};
const _hoisted_14 = {
  class: "number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
    placeholder: "名称",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputValue = $event)
  }, null, 512), [[_vModelText, $data.inputValue]]), _createElementVNode("div", {
    class: "search-icon",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.search && $options.search(...args))
  }, _cache[3] || (_cache[3] = [_createElementVNode("img", {
    src: _imports_0,
    class: "search-icon"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannersList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.showBigImage && _ctx.showBigImage(...args)),
      src: item.bannerImage
    }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.bannerName), 1)])]);
  }), 256))])], 512), _createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("div", null, [_createElementVNode("span", {
    style: {
      "color": "#c9b670",
      "font-size": "0.55rem"
    }
  }, "|"), _createElementVNode("span", {
    class: "my-title"
  }, "展厅列表")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.museumList, item => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.showMuseumList(item),
      class: "exhibition"
    }, [_createElementVNode("img", {
      class: "exhibition-img",
      src: item.imgPath
    }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, _toDisplayString(item.shortName), 1), _createElementVNode("div", _hoisted_13, [_cache[4] || (_cache[4] = _createElementVNode("img", {
      class: "eye",
      src: _imports_1
    }, null, -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(item.adLink), 1)]), _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "line"
    }, null, -1))], 8, _hoisted_10);
  }), 256))])]);
}